export const APP_NAME = 'LaunchPad'
export const CEO_EMAIL = 'shawn@jetpacklabs.com'
